import { graphql } from "lib/generated/app-service-gql";
import {
  OnAiChatResponseSubscription,
  OnAiChatResponseSubscriptionVariables,
} from "lib/generated/app-service-gql/graphql";
import { useSubscription, UseSubscriptionOptions } from "../useGraphQlClient";

// adding this so it generates the types
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _onAiChatResponse = graphql(`
  subscription onAiChatResponse($conversationId: String!) {
    onAiChatResponse(conversationId: $conversationId) {
      conversationId
      resourceId
      resourceType
      question
      answer
      sources {
        id
        type
        title
        url
        chunkNumber
        locations {
          pageNumber
          bbox {
            x
            y
            width
            height
          }
        }
        documentType
        filePath
        citationId
        isDeleted
      }
      isComplete
      thinking
    }
  }
`);

export function useAiChatStreamSubscription(
  conversationId: string,
  options: UseSubscriptionOptions<OnAiChatResponseSubscription>,
) {
  return useSubscription<OnAiChatResponseSubscription, OnAiChatResponseSubscriptionVariables>(
    `
  subscription onAiChatResponse($conversationId: String!) {
    onAiChatResponse(conversationId: $conversationId) {
      conversationId
      resourceId
      resourceType
      question
      answer
      sources {
        id
        type
        title
        url
        chunkNumber
        locations {
          pageNumber
          bbox {
            x
            y
            width
            height
          }
        }
        documentType
        filePath
        citationId
        isDeleted
      }
      isComplete
      thinking
    }
  }
  `,
    { conversationId },
    { ...options },
  );
}
